import { useSelector } from 'react-redux';
import BootstrapTable from 'react-bootstrap-table-next';
import { AnalyticsSpinner } from '../../../components/common/Spinner/AnalyticsSpinner';

import styles from './OperatorSellerPage.module.scss';

export function OperatorContacts() {
  const {
    contacts,
    loading: { contacts: loading },
  } = useSelector((state) => state.operators);

  const columns = [
    {
      text: 'Name',
      dataField: 'firstName',
      formatter: (cell, row) => [row.firstName, row.lastName].join(' '),
      sort: true,
    },
    {
      text: 'Email',
      dataField: 'email',
      formatter: (cell) => (
        <span>
          <a href={`mailto:${cell}`}>{cell}</a>
        </span>
      ),
      sort: true,
    },
    {
      text: 'Phone',
      dataField: 'phone',
    },
  ];

  return (
    <fieldset className={styles.sectionWrapper}>
      <h2>Seller's Contacts</h2>

      {loading || !contacts?.length ? (
        <div className={styles.emptyTable}>{loading ? <AnalyticsSpinner /> : <h3>No contacts for seller</h3>}</div>
      ) : (
        <div className={styles.tableWrapper}>
          <BootstrapTable
            data={contacts}
            columns={columns}
            keyField="email"
            striped
            hover
            bordered={false}
            className={styles.container}
          />
        </div>
      )}
    </fieldset>
  );
}
